/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Ready_For_PickupInputs */

const vi_notif_type_ready_for_pickup = /** @type {(inputs: Notif_Type_Ready_For_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng giao`)
};

/**

* @param {Notif_Type_Ready_For_PickupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_ready_for_pickup = /** @type {((inputs?: Notif_Type_Ready_For_PickupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Ready_For_PickupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_ready_for_pickup(inputs)
});